import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarTechnicalInfoFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M6.04532 3.9375H6.82216H18.2159H18.9927V4.71435V11.7712L17.439 11.1196V5.4912H7.59901V12.4583L7.24872 12.6553L7.02276 12.6972L7.02273 12.6972C6.67708 12.7612 6.35145 12.8215 6.04532 12.8816V4.71435V3.9375ZM8.89425 8.59839H16.1448V7.04469H8.89425V8.59839ZM5.53293 18.747H4.99754C4.29391 18.7644 3.80005 18.1496 3.80005 17.5265V16.6261L3.80033 16.6179C4.03835 14.6058 5.28571 14.3748 7.8381 13.9022L8.02708 13.8672L10.0107 12.7514C10.6446 12.3605 11.3705 12.1535 12.1111 12.1535L14.9917 12.1542C15.3776 12.1725 15.7577 12.256 16.1168 12.4011L20.2 14.1137V17.6415L18.4852 18.4158C17.8196 20.628 15.1875 20.4743 14.5188 18.747H9.40147C8.5399 20.7241 6.02304 20.263 5.53293 18.747ZM16.1448 11.1879H8.89425V9.63418H16.1448V11.1879Z"
      />
    </SvgIcon>
  );
});
